// Libs
import React, { useState, useEffect } from 'react';

// Own Libs
import { Button, GridView, Widget } from '@digital/ui';

//Api
import {
  exportarCrfFechamentoCicloOrcamentario,
  exportarCrfFechamentoCicloOrcamentarioProjetoPacote,
  getCrfFechamentoCicloAnoByFechamentoId
} from '@app/api/crf/crffechamento';

import {
  CrfCicloOrcamentarioRelatorio,
  CrfFiltros
} from '@app/api/crf/crfRelatorioCicloOrcamentario';

//Files

//Utils

import RelatorioCicloOrcamentarioTabela from '@app/views/crf/Modulo/ContaResultado/Relatorios/RelatorioCicloOrcamentario/relatorioCicloOrcamentarioTabela';
import { hasPermission } from '@app/helpers/permissions';


interface FechamentoCicloOrcamentarioProps {
  fechamentoId: string;
}

const FechamentoCicloOrcamentario = (props: FechamentoCicloOrcamentarioProps) => {
  const { fechamentoId } = props;

  const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CrfCicloOrcamentarioRelatorio>();

  useEffect(() => {
    if (fechamentoId) {
      getCrfFechamentoCicloAnoByFechamentoId(fechamentoId).then(result => {
        setCicloOrcamentarioRelatorioTotal(result);
      });
    }
  }, [fechamentoId]);

  const btnExportar = () => {
    const btnResult = [];

    if (fechamentoId) {
      if (hasPermission(['FECHAMENTO_CICLO_ORCAMENTARIO_BOTAO_EXPORTA_RELATORIO_VISUALIZAR'])) {
        btnResult.push(
          <Button
            type="primary"
            size={'small'}
            icon="files-ms_excel"
            onClick={() => {
              exportarCrfFechamentoCicloOrcamentario(fechamentoId, 'exportarFechamentoCicloOrcamentario.xlsx');
            }}>
            Exporta Relatório
          </Button>,
        );
      }

      if (hasPermission(['FECHAMENTO_CICLO_ORCAMENTARIO_BOTAO_EXPORTA_RELATORIO_PROJETO_PACOTE_VISUALIZAR'])) {
        btnResult.push(
          <Button
            type="primary"
            size={'small'}
            icon="files-ms_excel"
            onClick={() => {
              exportarCrfFechamentoCicloOrcamentarioProjetoPacote(fechamentoId, 'cicloOrcamentarioProjetoPacote.xlsx');
            }}>
            Exporta Relatório Projeto Pacote
          </Button>,
        );
      }
    }

    return btnResult;
  };

  return (
    <GridView noform>
      <Widget title="RESULTADO" span={12} actions={btnExportar()}>
        {cicloOrcamentarioRelatorioTotal && fechamentoId ? (
          <RelatorioCicloOrcamentarioTabela
            cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
            filtro={{} as CrfFiltros}
            mostrarColunaDetalhe={false}
            quantidadeItemPaginacao={10}
            mostrarColunaDetalheFechamento={true}
            fechamentoId={fechamentoId}
          />
        ) : (
          <> </>
        )}
      </Widget>
    </GridView>
  );
};

export default FechamentoCicloOrcamentario;
